<template>
  <div class="container">
    <img class="title"
         src="../assets/join-us-title.svg" />
    <p>
      我們與孩子們共享學習的快樂以及榮耀。<br />
      教育是我們的使命，也是我們樂此不疲的事。<br />
      高僑是一間超過27年的老字號補習班，<br />
      然而它願意實現創新，成為年輕人實現夢想的舞台。<br />
      如果你／妳對服務熱忱，熱衷教育，有年輕的態度，對夢想的堅持，歡迎你加入我們。
    </p>
    <section class="list">
      <h4>師資/人才教育訓練<br />高僑的每一位，都是關鍵</h4>
      <ul>
        <li>
          高僑的學生與老師共享上課的時間與空間，互相提出問題激盪，讓彼此成長！
        </li>
        <li>
          高僑的小班制重視孩子的個人特質以及與家長間的親密溝通。
        </li>
        <li>
          高僑的行政重視專業，把最好的呈現給孩子與家長，讓每位孩子用最好的環境與書本學習，以及讓每位家長最快速、最正確地去瞭解孩子的學習大事！
        </li>
      </ul>
      <h4>國小</h4>
      <ul>
        <li>
          自然科學實驗/資優數學/國語文/社會科教師
        </li>
        <li>
          擅長與家長溝通，具親和力
        </li>
        <li>
          完善培訓制度，並有長期上課的準備，短期兼差勿試
        </li>
        <li>
          具國小代課經驗優
        </li>
      </ul>
      <h4>國中</h4>
      <ul>
        <li>
          數學/理化/生物/地科/國文/英文/社會科教師
        </li>
        <li>
          相關科系畢業者優
        </li>
        <li>
          具實際教學經驗尤佳
        </li>
        <li>
          國小高年級、國高中補教經驗
        </li>
        <li>
          歡迎國中代課老師
        </li>
      </ul>
      <h4>行政人員</h4>
      <ul>
        <li>
          喜歡小孩子，對教育有興趣
        </li>
        <li>
          有教育、服務業等相關經驗尤佳
        </li>
        <li>
          擅長與人互動溝通，具親和力，能與孩子相處
        </li>
        <li>
          可獨立作業，具應變能力
        </li>
        <li>
          我們在乎你的未來規劃，短期兼差勿試
        </li>
      </ul>
      <h4>總部人員</h4>
      <ul>
        <li>
          具工作熱忱，態度積極
        </li>
        <li>
          上下班時間固定
        </li>
        <li>
          具專業文書能力，請詳見人力銀行網站
        </li>
      </ul>
    </section>
    <p>
      也許以上未必完全符合，也歡迎有意願者來信應徵！請在你/妳的信件中說明應徵動機、附上履歷、相關經歷、作品或任何加分條件至
      <a target="_blank"
         href="mailto:kaochiao.hr01@gmail.com">
        kaochiao.hr01@gmail.com
      </a>
      ，或到1111人力銀行投履歷也OK！我們會儘速與你/妳聯絡！<br />
      （檔名請標註姓名，主旨記得填寫你的姓名及想應徵的職位）
    </p>
    <div class="flow">
      <a class="btn"
         target="_blank"
         href="https://www.1111.com.tw/corp/2150188/">
        <img src="../assets/to-1111-btn.png" />
      </a>
      <img class="bg desktop"
           src="../assets/join-us-flow.svg" />
      <img class="bg mobile"
           src="../assets/join-us-flow-mobile.png" />
    </div>
    <section class="culture mobile">
      <h4>我們的文化</h4>
      <dl>
        <dt>對教育貢獻</dt>
        <dd>以學生的學習為己任，而不是以營收為目的。</dd>
        <dt>對孩子付出</dt>
        <dd>我們在做的事，能影響孩子的未來，甚至一輩子。</dd>
        <dt>對家長關懷</dt>
        <dd>解決家長對孩子學習的擔憂，放心把孩子交給高僑來培育。</dd>
        <dt>對社會盡責</dt>
        <dd>讓每個人都受惠，為台灣的教育貢獻心力。</dd>
      </dl>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 60px;
  padding: 60px 0;
  position: relative;
  background: url("../assets/news-header.png") no-repeat;
  background-size: 100% auto;

  .title {
    margin: auto;
    display: block;
    width: 160px;
  }

  p {
    margin: 30px auto;
    text-align: center;
    color: #3b3b3b;
    font-size: 18px;
    line-height: 1.5rem;
    letter-spacing: 3px;
    font-weight: bold;
    max-width: 600px;

    a {
      text-decoration: none;
      color: #3b3b3b;
    }
  }

  h4 {
    color: #1c2e53;
    font-size: 18px;
  }

  .list {
    max-width: 500px;
    margin: auto;

    ul {
      padding-left: 1rem;
      margin: 13px auto;

      li {
        font-size: 16px;
        color: #3b3b3b;
        list-style: none;
        line-height: 1.5rem;
        letter-spacing: 3px;

        &:before {
          content: "\2022";
          color: #e06960;
          font-weight: bold;
          font-size: 14px;
          display: inline-block;
          width: calc(1rem - 4px);
          margin-left: -1rem;
        }
      }
    }
  }

  .flow {
    margin-top: 40px;
    max-width: 1200px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn {
      margin-bottom: 15px;
    }

    .bg {
      width: 100%;
    }
  }
}

@media (max-width: 480px) {
  p,
  h4,
  ul {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}

@media (max-width: 1023px) {
  .flow {
    .btn {
      display: block !important;
      position: initial !important;
      margin: 20px auto !important;
      left: 0 !important;
      text-align: center !important;
    }
  }

  .culture {
    margin: 20px 10px 0;
    text-align: center;

    dl {
      margin: 15px 0;
      dt {
        margin: 0;
        font-size: 12px;
        color: #3b4a6a;
      }

      dd {
        margin: 5px 0;
        font-size: 12px;
        color: #3b3b3b;
      }
    }
  }
}
</style>
